module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0123.jpg?v=a781a7b8";